function handleFullScreen(dialog, isFullScreen, marginTop, width) {
    if(!dialog) return false;
    if(isFullScreen) {
        dialog.classList.add('is-fullscreen');
        dialog.style.marginTop = "0";
        dialog.style.width = "100%";
    }else {
        dialog.classList.remove('is-fullscreen');
        dialog.style.marginTop = marginTop;
        dialog.style.width = width;
    }
}

const dialogFullscreen = {
    name: 'fullscreen',
    bind: function(el, binding, vnode) {
        // console.log('dialogFullscreen', el, binding, vnode);

        const dialog = el.querySelector(".el-dialog");
        const header = el.querySelector(".el-dialog__header");
        if(!header || !dialog || !vnode) {
            throw new Error(`el-dialog is not bound!`);
        }
        const expression = binding.expression;
        const orFullscreen = vnode.context[expression];
        let isFullScreen = orFullscreen || false;
        const dialogVm = vnode.componentInstance;
        const { width, top } = vnode.componentInstance;

        dialogVm.$on('closed', () => {
            setTimeout(() => {
                isFullScreen = orFullscreen;
                dialogVm.$emit('fullscreen', isFullScreen);
                handleFullScreen(dialog, isFullScreen, top, width);
            }, 200);
        });

        if(isFullScreen) {
            handleFullScreen(dialog, isFullScreen, top, width);
        }

        const fullScreenBtn = document.createElement("button");
        fullScreenBtn.type = "button";
        fullScreenBtn.className = "el-dialog__headerbtn";
        fullScreenBtn.style = "right: 50px;";

        const fullScreenIcon = document.createElement("i");
        fullScreenIcon.className = "el-icon el-icon-full-screen";
        fullScreenBtn.append(fullScreenIcon);

        fullScreenBtn.addEventListener("click", () => {
            isFullScreen = !isFullScreen;
            dialogVm.$emit('fullscreen', isFullScreen);
            handleFullScreen(dialog, isFullScreen, top, width);
            return false;
        });

        header.append(fullScreenBtn);

        header.addEventListener("dblclick", () => {
            isFullScreen = !isFullScreen;
            dialogVm.$emit('fullscreen', isFullScreen);
            handleFullScreen(dialog, isFullScreen, top, width);
            return false;
        });
    }
};

export default dialogFullscreen;
